import { render } from "./or-news-page-content.vue?vue&type=template&id=04b290e6&scoped=true&bindings={\"selected_news\":\"data\",\"all_news\":\"data\",\"news\":\"data\",\"scroll_top\":\"data\",\"additional_part_of_news\":\"data\",\"getFromState\":\"options\",\"select\":\"options\",\"more_news\":\"options\"}"
import script from "./or-news-page-content.vue?vue&type=script&lang=js"
export * from "./or-news-page-content.vue?vue&type=script&lang=js"

import "./or-news-page-content.vue?vue&type=style&index=0&id=04b290e6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-04b290e6"

export default script